"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckoutStep = void 0;
var CheckoutStep;
(function (CheckoutStep) {
    CheckoutStep[CheckoutStep["CART"] = 1] = "CART";
    CheckoutStep[CheckoutStep["CHECKOUT"] = 2] = "CHECKOUT";
    CheckoutStep[CheckoutStep["LAST_CHECK"] = 3] = "LAST_CHECK";
})(CheckoutStep || (exports.CheckoutStep = CheckoutStep = {}));
//# sourceMappingURL=CheckoutStep.js.map